const Slack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.07018 6.86951L3.20533 6.87334C1.98943 6.87515 1.00391 7.86061 1.00391 9.07405C1.00129 10.2875 1.9856 11.2717 3.2015 11.2725L9.06716 11.2687C10.2833 11.2671 11.2688 10.2816 11.2688 9.068C11.2704 7.85376 10.2861 6.86951 9.07018 6.86951ZM9.07401 1.00391C7.85811 1.00552 6.87341 1.99098 6.87361 3.20462C6.8718 4.41805 7.85611 5.4021 9.07201 5.4023L11.272 5.40069L11.2734 3.2024C11.2752 1.98896 10.2909 1.00491 9.07401 1.00391C9.07502 1.00391 9.07502 1.00391 9.07401 1.00391Z"
        fill="#36C5F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1334 9.06329L17.1372 3.19769C17.139 1.98506 16.1555 1.00101 14.9396 1C13.7237 1.00161 12.7382 1.98707 12.7382 3.20051L12.7344 9.06631C12.7318 10.2797 13.7161 11.2638 14.932 11.2648C16.1479 11.2632 17.1334 10.2777 17.1334 9.06329ZM22.999 9.05946C23.0008 7.84582 22.0166 6.86177 20.8007 6.86177C19.5846 6.86338 18.599 7.84885 18.599 9.06228L18.5976 11.2624L20.7976 11.261C22.0135 11.2592 22.9992 10.2737 22.999 9.05946Z"
        fill="#2EB67D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.929 17.1295L20.7946 17.1257C22.0105 17.1239 22.9963 16.1384 22.9961 14.925C22.9987 13.7116 22.0144 12.7273 20.7985 12.7265L14.9328 12.7303C13.7169 12.7319 12.7312 13.7174 12.7314 14.931C12.7296 16.1453 13.7131 17.1295 14.929 17.1295ZM14.9252 22.9961C16.1411 22.9943 17.1266 22.0089 17.1266 20.7954C17.1282 19.582 16.1439 18.5977 14.928 18.5977L12.728 18.5992L12.7266 20.7985C12.725 22.0109 13.7091 22.9951 14.9252 22.9961Z"
        fill="#ECB22E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.86567 14.9357L6.86184 20.8013C6.85922 22.0148 7.84352 22.999 9.05942 23C10.2753 22.9982 11.2608 22.0127 11.2608 20.7993L11.2647 14.9345C11.2673 13.7211 10.283 12.737 9.06709 12.736C7.85038 12.7368 6.86567 13.7223 6.86567 14.9357ZM1 14.9396C0.998189 16.1532 1.98249 17.1372 3.1984 17.1372C4.4145 17.1356 5.40002 16.1502 5.40002 14.9367L5.40142 12.7376L3.20143 12.739C1.98552 12.7407 0.999803 13.7261 1 14.9396Z"
        fill="#E01E5A"
      />
    </svg>
  );
};

export default Slack;
